module.exports = __webpack_public_path__ + "img/pc.06dac826.png";